/**
 * Texto con marcas de tiempo clicables (pedido 2026-07-30: "cuando habla de secciones de la
 * llamada que ponga en qué segundos de la grabación dijo eso"). La IA escribe los momentos
 * como `[4:12]` tanto en el resumen como en la transcripción; acá se convierten en un chip que
 * mueve el reproductor a ese segundo — de nada sirve el minuto si hay que buscarlo a mano.
 */

const TS_RE = /\[(\d{1,2}:)?(\d{1,2}):(\d{2})\]/g;

/** "[1:04:12]" o "[4:12]" → segundos. */
function toSeconds(h: string | undefined, m: string, s: string): number {
  return (h ? Number(h.slice(0, -1)) * 3600 : 0) + Number(m) * 60 + Number(s);
}

export function TimedText({ text, onSeek, style }: {
  text: string;
  /** Si no se pasa, las marcas se pintan pero no son clicables (no hay audio que mover). */
  onSeek?: (seconds: number) => void;
  style?: React.CSSProperties;
}) {
  const out: React.ReactNode[] = [];
  let last = 0;
  let match: RegExpExecArray | null;
  TS_RE.lastIndex = 0;
  while ((match = TS_RE.exec(text)) !== null) {
    if (match.index > last) out.push(text.slice(last, match.index));
    const secs = toSeconds(match[1], match[2]!, match[3]!);
    const label = match[0].slice(1, -1);
    out.push(
      onSeek ? (
        <button
          key={`${match.index}-${label}`}
          type="button"
          onClick={() => onSeek(secs)}
          title={`▶ ${label}`}
          style={{
            font: 'inherit', fontSize: '0.92em', fontVariantNumeric: 'tabular-nums', cursor: 'pointer',
            background: 'var(--accent-soft)', color: 'var(--accent)', border: 'none', borderRadius: 5,
            padding: '0 5px', margin: '0 1px', fontWeight: 600,
          }}
        >▶ {label}</button>
      ) : (
        <span key={`${match.index}-${label}`} style={{ fontVariantNumeric: 'tabular-nums', opacity: 0.75 }}>[{label}]</span>
      ),
    );
    last = match.index + match[0].length;
  }
  if (last < text.length) out.push(text.slice(last));
  return <span style={style}>{out}</span>;
}
